import { Box, Typography, useTheme } from "@mui/material";
import { map } from "lodash-es";
import React from "react";
import { Link } from "react-router-dom";

import { useHomePages } from "~/queries";

export const FooterList: React.FC = () => {
  const { data: pages } = useHomePages();
  const theme = useTheme();

  return (
    <Box
      mt={{ xs: 1, md: 2 }}
      sx={{
        display: "grid",
        gap: 1,
        gridTemplateColumns: {
          xs: "1fr 1fr",
          sm: "1fr 1fr",
          md: "1fr",
        },
        justifyItems: { xs: "center", md: "start" },
      }}
    >
      {map(pages, (p) => (
        <Link
          to={`/pages/${p.id}`}
          key={p.id}
          style={{
            textDecoration: "none",
            color: theme.palette.text.secondary,
            fontWeight: 500,
            fontSize: theme.typography.body2.fontSize,
            padding: "2px 0",
            borderRadius: 4,
            transition: "background 0.2s",
            display: "block",
          }}
          onMouseOver={(e) =>
            (e.currentTarget.style.background = theme.palette.action.hover)
          }
          onMouseOut={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <Typography variant="body2">{p.title}</Typography>
        </Link>
      ))}
    </Box>
  );
};
